import React__default from 'react';
import 'rc-field-form';

const FormContext = React__default.createContext({
  labelAlign: "right",
  vertical: false,
  itemRef: () => () => {
  }
});
React__default.createContext(null);

export { FormContext };
